<div *ngIf="recentOrder" class="order-process d-inline-flex justify-content-between align-items-center">

  <p class="text-w-500 title-8 text-secondary mb-0">{{multilingualService.langMap?.LABEL_HOME_ORDER}}
    {{recentOrder.orderNumber}}</p>
  <p *ngIf="showPrescription" class="text-w-300 title-8 text-secondary mb-0 ml-2">
    {{recentOrder.prescriptionFills.dispensedDrugName}}</p>

  <div *ngIf="!isOrionUser; else statusbar2"
    class="progress-container d-flex justify-content-between relative">
    <div class="progress-block">
      <div [class.active]="stepNo>=1" class="circle d-flex justify-content-center align-items-center">
        <mat-icon class="icon-check-mark d-flex justify-content-center align-items-center"></mat-icon>
      </div>
      <p>{{multilingualService.langMap?.LABEL_HOME_PAYMENT}}</p>
    </div>
    <div class="progress-block">
      <div [class.active]="stepNo>=2" class="circle d-flex justify-content-center align-items-center">
        <mat-icon class="icon-check-mark d-flex justify-content-center align-items-center"></mat-icon>
      </div>
      <p>{{multilingualService.langMap?.LABEL_HOME_IN_PROGRESS}}</p>
    </div>
    <div class="progress-block">
      <div [class.active]="stepNo>=3" class="circle d-flex justify-content-center align-items-center">
        <mat-icon class="icon-check-mark d-flex justify-content-center align-items-center"></mat-icon>
      </div>
      <p *ngIf="stepNo===3">{{ recentOrder.orderStatus==='Shipped'? multilingualService.langMap?.LABEL_HOME_IN_SHIPPED :
        multilingualService.langMap?.LABEL_ORDER_PICKED_UP }}</p>
      <p *ngIf="stepNo!==3">{{ recentOrder.pickUp == 'Y' ? multilingualService.langMap?.LABEL_ORDER_PICKED_UP :
        multilingualService.langMap?.LABEL_HOME_IN_SHIPPED}}</p>
    </div>
  </div>

  <ng-template #statusbar2>
    <div class="progress-container d-flex justify-content-between relative">
      <div class="progress-block">
        <div
          [class.active]="stepNo >= 1"
          class="circle d-flex justify-content-center align-items-center"
        >
          <mat-icon
            class="icon-check-mark d-flex justify-content-center align-items-center"
          ></mat-icon>
        </div>
        <p>{{ multilingualService.langMap?.LABEL_HOME_IN_PROGRESS }}</p>
      </div>

      <div
        class="progress-block"
        *ngIf="(recentOrder.orderStatus === orderCancelledStatus || recentOrder.orderStatus === orderPickedUpStatus); else activeOrders"
      >
        <ng-container *ngIf="recentOrder.orderStatus === orderCancelledStatus">
          <div
          [class.active]="stepNo >= 2"
          class="circle red-circle d-flex justify-content-center align-items-center"
          >
            <mat-icon
              class="icon-cross d-flex justify-content-center align-items-center"> </mat-icon>
          </div>
          <p>{{multilingualService.langMap?.LABEL_HOME_CANCELLED}}</p>
        </ng-container>

        <ng-container *ngIf="recentOrder.orderStatus === orderPickedUpStatus">
          <div
          [class.active]="stepNo >= 2"
          class="circle d-flex justify-content-center align-items-center"
        >
          <mat-icon 
            class="icon-check-mark d-flex justify-content-center align-items-center"> </mat-icon>
          </div>
          <p> {{multilingualService.langMap?.LABEL_ORDER_PICKED_UP}} </p>
        </ng-container>
      </div>

      <ng-template #activeOrders>
        <div class="progress-block">
          <div
            [class.active]="stepNo >= 2"
            class="circle d-flex justify-content-center align-items-center"
          >
            <mat-icon
              class="icon-check-mark d-flex justify-content-center align-items-center"
            ></mat-icon>
          </div>
          <p>{{ multilingualService.langMap?.LABEL_HOME_IN_SHIPPED }}</p>
        </div>
      </ng-template>
    </div>
  </ng-template>
</div>
